import { rgba } from 'polished'
import { VFC } from 'react'
import { lightorange, _modaloverlay } from 'src/styles/colors'
import styled, { keyframes } from 'styled-components'

export const Loading: VFC<{ isLoading: boolean }> = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <LoadingWrapper>
          <LoadingSpinner>
            <div></div>
            <div></div>
            <div></div>
          </LoadingSpinner>
        </LoadingWrapper>
      )}
    </>
  )
}

export const SideMenuLoading: VFC<{ isLoading: boolean }> = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <SideMenuLoadingWrapper>
          <LoadingSpinner>
            <div></div>
            <div></div>
            <div></div>
          </LoadingSpinner>
        </SideMenuLoadingWrapper>
      )}
    </>
  )
}

const lsLoading = keyframes`
  0% {
      top: 8px;
      height: 64px;
    }
  50%,
  100% {
    top: 24px;
    height: 32px;
  }
`

const LoadingWrapper = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background: ${rgba(_modaloverlay, 0.5)};
`
const LoadingSpinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  width: 80px;
  height: 80px;
  div {
    display: inline-block;
    position: absolute;
    left: 8px;
    width: 10px;
    background: ${lightorange};
    animation: ${lsLoading} 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    &:nth-child(1) {
      left: 8px;
      animation-delay: -0.24s;
    }
    &:nth-child(2) {
      left: 32px;
      animation-delay: -0.12s;
    }
    &:nth-child(3) {
      left: 56px;
      animation-delay: 0s;
    }
  }
  }
`

const SideMenuLoadingWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 50%;
`
